<template>
  <ba-dialog
    :save="save"
    title="Connect BitGo"
    :canSave="!canSave"
    :show-button="false"
    :show="showDialog"
    :onHide="hideDialog"
  >
    <v-container fluid grid-list-xl>
      <v-layout wrap>
        <v-flex xs12 lg6>
          <p>
            We recommend that the API credentials you are sharing with us be
            <b>read-only</b>.
          </p>
          <p>
            When setting up, use the following IP Addresses in the IP Whitelist:
            <br />104.196.183.18 <br />35.230.22.143
          </p>
          <v-text-field label="Token" v-model="token"></v-text-field>
          <v-autocomplete
            v-model="exchangeContactId"
            :items="contacts"
            :label="$t('_exchangeContact')"
            item-text="name"
            item-value="id"
            persistent-hint
          ></v-autocomplete>
          <v-btn :disabled="!canValidate" @click="validate" :loading="isValidating">{{ $t('_validate') }}</v-btn>
        </v-flex>

        <v-flex xs6 v-if="canValidate">
          <validation-summary
            ref="connectionValidation"
            :validation-data="validationData"
            account-type="BitGo Connection"
          />
        </v-flex>
      </v-layout>

      <v-layout v-if="errorMessage" wrap align-center>
        <v-flex xs12 class="tw-text-red-400">
          {{ errorMessage }}
        </v-flex>
      </v-layout>
    </v-container>
  </ba-dialog>
</template>

<script>
import gql from 'graphql-tag';

import ValidationSummary from '@/components/validation/AccountValidationSummary';
export default {
  components: { ValidationSummary },
  props: ['org', 'refresh'],
  data() {
    return {
      token: '',
      exchangeContactId: '',
      showDialog: false,
      errorMessage: null,
      validationData: null,
      isValid: false,
      isValidating: false,
    };
  },
  computed: {
    canValidate() {
      return this.token;
    },
    canSave() {
      return this.token && this.exchangeContactId && this.isValid && !this.isValidating;
    },
    contacts() {
      return this.$store.getters['contacts/ENABLED_CONTACTS'];
    },
  },
  watch: {
    showDialog() {
      if (this.showDialog) {
        this.resetForm();
      }
    },
    token() {
      this.isValid = false;
    },
  },
  methods: {
    resetForm() {
      this.token = '';
      this.exchangeContactId = '';
      this.errorMessage = null;
      this.isValidating = false;
      this.isValid = false;
    },
    hideDialog() {
      this.showDialog = false;
      this.resetForm();
    },
    show() {
      this.showDialog = true;
    },
    async validate() {
      if (!this.canValidate) {
        return;
      }
      try {
        this.isValidating = true;
        const vars = {
          createBitGo: {
            token: this.token,
            exchangeContactId: this.exchangeContactId,
          },
        };
        const validation = await this.$refs.connectionValidation.validate(vars);
        this.isValid = validation && validation.success;
        this.isValidating = false;
      } catch (error) {
        this.isValid = false;
        this.isValidating = false;
      }
    },
    save() {
      // reset error message
      this.errorMessage = null;

      const vars = {
        orgId: this.$store.state.currentOrg.id,
        create: {
          createBitGo: {
            token: this.token,
            exchangeContactId: this.exchangeContactId,
          },
        },
      };
      this.$apollo
        .mutate({
          // Query
          mutation: gql`
            mutation CreateConnection($orgId: ID!, $create: CreateConnectionInput!) {
              createConnection(orgId: $orgId, create: $create) {
                success
                errors
                message
              }
            }
          `,
          // Parameters
          variables: vars,
        })
        .then(() => {
          if (this.errorMessage) {
            return { error: this.errorMessage };
          } else {
            this.resetForm();

            if (this.refresh) {
              this.refresh();
            }

            this.showDialog = false;
          }
        })
        .catch((err) => {
          const errors = err.graphQLErrors.map((e) => e.message);
          this.errorMessage = '* ' + errors[0];
        });
    },
  },
};
</script>
